import { render } from "./Step1.vue?vue&type=template&id=5c654d26"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__